import { render, staticRenderFns } from "./ScanPage-History.vue?vue&type=template&id=a2bf0168&scoped=true"
import script from "./ScanPage-History.vue?vue&type=script&lang=js"
export * from "./ScanPage-History.vue?vue&type=script&lang=js"
import style0 from "./ScanPage-History.vue?vue&type=style&index=0&id=a2bf0168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bf0168",
  null
  
)

export default component.exports